/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/context_menu.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    contextMenuModule
} from "../../../grids/grid_core/context_menu/m_context_menu";
import treeListCore from "../m_core";
treeListCore.registerModule("contextMenu", contextMenuModule);
